// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__f1vCn","colBig":"styles_colBig__cJNah","colSmall":"styles_colSmall__1M7Ya"};